import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 * Modale de confirmation de suppression du brouillon DIA.
 * Utilisée pour remplacer le window.confirm() natif.
 */
@Component({
  selector: 'app-modal-confirm-delete',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">Supprimer le brouillon</h4>
      <button type="button" class="close" aria-label="Fermer" (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p>Êtes-vous sûr de vouloir supprimer le brouillon ?</p>
      <p class="text-danger">
        <i class="fa fa-exclamation-triangle"></i>
        Toutes les données saisies seront perdues et vous serez redirigé vers le début du formulaire.
      </p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Annuler</button>
      <button type="button" class="btn btn-danger" (click)="activeModal.close('confirm')">Supprimer</button>
    </div>
  `
})
export class ModalConfirmDeleteComponent {
  constructor(public activeModal: NgbActiveModal) {}
}



// WEBPACK FOOTER //
// ./src/app/components/modal-confirm-delete/modal-confirm-delete.component.ts